import { z } from 'zod';
import { requiredApplicationIdString } from '../helper';
import { baseResidentialApplicant } from '../shared';
import { ApplicationStep } from '../types';

export const createJointApplicantSchema = baseResidentialApplicant
  .pick({
    firstName: true,
    middleName: true,
    lastName: true,
    email: true,
    phone: true,
  })
  .and(
    z.object({
      applicationId: requiredApplicationIdString(),
      step: z.literal(ApplicationStep.AddJointApplicant),
    }),
  );
